import { render, staticRenderFns } from "./SelectWide.vue?vue&type=template&id=4fc41e76&scoped=true&lang=pug&"
import script from "./SelectWide.vue?vue&type=script&lang=ts&"
export * from "./SelectWide.vue?vue&type=script&lang=ts&"
import style0 from "./SelectWide.vue?vue&type=style&index=0&id=4fc41e76&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc41e76",
  null
  
)

export default component.exports